import { Config } from 'common/config'
import { MenuContext } from 'common/contexts/Menu'
import { useResolution } from 'common/hooks'
import { FlexWrapper } from 'components/Styled/Styled'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Component } from '..'
import { Container, Item, NavLinkStyled, StyledGeneralMenu } from './styled'
import { useLocation, useNavigate } from 'react-router-dom'

export const Menu = () => {
  const { t } = useTranslation()
  const { isMinScreen1000 } = useResolution()
  const { setIsOpen } = useContext(MenuContext)
  const navigate = useNavigate()

  const { pathname } = useLocation()

  const isBanquetPage = pathname.includes('/banquet')
  const items = [
    {
      title: t('about.us'),
      href: pathname.includes('/banquet') ? '/' : `#${Config.Section.aboutUs}`,
    },
    {
      title: t('other.bookmarks'),
      href: pathname.includes('/banquet')
        ? '/'
        : `#${Config.Section.anotherRestaurants}`,
    },
    {
      title: t('contacts'),
      href: `#${Config.Section.contacts}`,
    },
  ]

  const onItemClick = (item: { title: string; href: string }) => {
    if (isBanquetPage && item.href === '/') {
      navigate('/')
      setIsOpen(false)
      return
    }
    const section = document.getElementById(item.href.replace('#', ''))
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' })
    }
    setIsOpen(false)
  }

  return (
    <>
      <Container>
        {!isMinScreen1000 && <StyledGeneralMenu />}
        <FlexWrapper direction="column" gap={isMinScreen1000 ? 56 : 28}>
          {items.map((item, index) => (
            <NavLinkStyled key={index} onClick={() => onItemClick(item)}>
              <Item>{item.title}</Item>
            </NavLinkStyled>
          ))}
        </FlexWrapper>
        <Component.Footer />
      </Container>
    </>
  )
}
